type ThreadPreviewSource = {
  title?: string;
  last_message_content?: string;
};

const sanitizePreview = (
  value: string | undefined,
  maxLength: number | null,
): string => {
  if (!value) return "";
  const normalized = value.replace(/\s+/g, " ").trim();
  if (maxLength === null || normalized.length <= maxLength) return normalized;
  return `${normalized.substring(0, maxLength)}…`;
};

export const getThreadPreviewText = (
  thread: ThreadPreviewSource,
  maxLength: number | null,
  preferTitle: boolean,
): string =>
  preferTitle
    ? sanitizePreview(thread.title, maxLength) ||
      sanitizePreview(thread.last_message_content, maxLength)
    : sanitizePreview(thread.last_message_content, maxLength) ||
      sanitizePreview(thread.title, maxLength);
